import { Context } from "@nuxt/types/app";
import { isFinite } from "lodash-es";

interface MbFromKbPlugin {
  getMBFromKB(number: number): number;
}

export default function (context: Context): MbFromKbPlugin {
  function getMBFromKB(number: number): number {
    if (!isFinite(number)) {
      return 0;
    }

    return number / 1024;
  }

  return { getMBFromKB };
}
